module.exports = __webpack_public_path__ + "img/LF008-06.8d8d073a.jpg";